import {
    CLEAR_CATEGORIES_LIST,
    RES_PER_PAGE,
    SAVE_CATEGORIES_LIST,
} from '../../constants/treatment-list-const/TreatmentListConst';

const initialState = {
    categoriesList: [],
    hasMore: false,
    totalCount: 0,
    curPage: 1,
};
export const TreatmentCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CATEGORIES_LIST:
            const newList = (state?.categoriesList).concat(action.payload.items);
            console.log('newList: ', newList);

            return {
                ...state,
                categoriesList: newList,
                totalCount: action.payload.total,
                curPage: Math.ceil(newList.length / RES_PER_PAGE),
                hasMore: action.payload.hasMore
            };

        case CLEAR_CATEGORIES_LIST:
            return {
                ...state,
                categoriesList: [],
                totalCount: 0,
                curPage: 1,
                hasmore: false,
            };
        default:
            return state;
    }
};
